import { QueryKeys } from "@/constants/queryKeys";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getRoomListingsForUser } from "../actions";
import useSession from "@/hooks/QueryHooks/useSession";

export const USER_LISTINGS_QUERY_KEYS = {
  all: [QueryKeys.USER_LISTINGS],
  getUserListings: (userId: string) => [
    ...USER_LISTINGS_QUERY_KEYS.all,
    "by-user",
    userId,
  ],
};

export function getUserListingsQueryOptions({
  userId,
  emailVerified,
}: {
  userId: string;
  emailVerified?: boolean;
}) {
  return queryOptions({
    queryKey: USER_LISTINGS_QUERY_KEYS.getUserListings(userId),
    queryFn: () => getRoomListingsForUser({ userId }),
    enabled: !!userId && !!emailVerified,
  });
}

export const useUserListings = () => {
  const { data: session } = useSession();
  return useQuery(
    getUserListingsQueryOptions({
      userId: session?.id,
      emailVerified: !!session?.emailVerified,
    })
  );
};
